import servise from '@/router/axios'

export const addContract = (data) => {
  return servise({
    url: '/contractForm/add/contract',
    method: 'post',
    data
  })
}

export const updateContract = (data) => {
  return servise({
    url: '/contractForm/put/contract',
    method: 'PUT',
    data
  })
}

export const deletetContract = (params) => {
  return servise({
    url: '/contractForm/get/contract',
    method: 'DELETE',
    params
  })
}
